import { Column, RowData, Table } from "@tanstack/react-table";

import { tstColumnMeta } from "../columnMeta";
import { TST_BLESSED_ID_COLUMN_SELECTION } from "../consts";

export interface AdjustableColumns<T extends RowData> {
    allColumns: Array<Column<T>>;
    orderedAccessorColumns: Array<Column<T>>;
    unpinnedAccessorColumnCount: number;
    pinnedColumns: Array<Column<T>>;
    pinnedWidth: number;
    selectionColumn: Column<T> | undefined;
    selectionInitiallyPinned: boolean;
}

// Read-only data of the table's column layout, in the order the adjust menu
// renders them. Pure derivation: no mutation, no side effects.
export function getAdjustableColumns<T extends RowData>(
    table: Table<T>
): AdjustableColumns<T> {
    const allColumns = table.getAllLeafColumns();

    const orderedAccessorColumns = [
        ...table.getLeftLeafColumns(),
        ...table.getCenterLeafColumns(),
    ].filter(
        (column) =>
            column.accessorFn !== undefined &&
            !tstColumnMeta(column)?.filterOnly
    );

    const unpinnedAccessorColumnCount = orderedAccessorColumns.filter(
        (column) => column.getIsPinned() !== "left"
    ).length;

    const selectionColumn = allColumns.find(
        (column) => column.id === TST_BLESSED_ID_COLUMN_SELECTION
    );
    const selectionInitiallyPinned =
        table.initialState.columnPinning?.left?.includes(
            TST_BLESSED_ID_COLUMN_SELECTION
        ) ?? false;

    const pinnedColumns = table.getLeftVisibleLeafColumns();
    const pinnedWidth = pinnedColumns.reduce(
        (sum, column) => sum + column.getSize(),
        0
    );

    return {
        allColumns,
        orderedAccessorColumns,
        unpinnedAccessorColumnCount,
        pinnedColumns,
        pinnedWidth,
        selectionColumn,
        selectionInitiallyPinned,
    };
}
